<template>
  <b-row>
    <b-col
      v-for="index in count"
      :key="index"
      md="6"
      lg="3"
    >
      <b-card

        no-body
      >
        <b-card-body>
          <card-content-loader />
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
} from 'bootstrap-vue'
import CardContentLoader from '@/components/loaders/CardContentLoader'

export default {
  name: 'MultiCardLoader',
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    CardContentLoader,
  },
  props: {
    count: {
      type: Number,
      default: () => 4,
    },
  },
}
</script>

<style scoped></style>
